import React from 'react';
import Header from '../../components/Header';

/**
 * Admin dashboard shell — Batch B1 fix: use the shared site Header
 * (Home / Logo / Search / Cart / Menu) instead of a custom dashboard
 * header. Account and sign-out live inside the Menu → Account page.
 *
 * Batch B2 Item 11 — Reduced wasted right-side space by widening the
 * dashboard content area to `max-w-[1600px]` and adding a mild responsive
 * padding scale so the panels breathe on ultra-wide displays without
 * looking cramped on smaller ones.
 */
export default function AdminShell({ title, tabs, activeTab, onTab, children }) {
    return (
        <div className="min-h-screen bg-sdf-ivory">
            <Header />
            <div className="sticky top-[52px] z-30 border-b border-sdf-line bg-white/70 backdrop-blur">
                <div className="max-w-[1600px] mx-auto px-3 sm:px-4 lg:px-6 overflow-x-auto no-scrollbar">
                    <div className="flex gap-2 py-2 w-max">
                        {tabs.map((t) => (
                            <button
                                key={t.key}
                                onClick={() => onTab(t.key)}
                                className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-semibold border transition-colors ${activeTab === t.key ? 'bg-sdf-red text-white border-sdf-red' : 'bg-white text-sdf-text border-sdf-line hover:bg-neutral-50'}`}
                                data-testid={`tab-${t.key}`}
                            >
                                {t.label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
            <main className="max-w-[1600px] mx-auto px-3 sm:px-4 lg:px-6 py-6 overflow-x-hidden">
                <h1 className="text-2xl font-extrabold">{title}</h1>
                <div className="mt-4 min-w-0">{children}</div>
            </main>
        </div>
    );
}
